import { type NudgeType, type ProductNudge } from '@/modules/nudges/aliases';

export function getNudgeByType(
  nudges: ProductNudge[] = [],
  type: NudgeType
): ProductNudge | undefined {
  return nudges.find((nudge) => nudge.type === type);
}
